"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EthQuery = require('eth-query');

var pify = require('pify');

var BaseFilterWithHistory = require('./base-filter-history');

var _require = require('./hexUtils'),
    bnToHex = _require.bnToHex,
    hexToInt = _require.hexToInt,
    incrementHexInt = _require.incrementHexInt,
    minBlockRef = _require.minBlockRef,
    blockRefIsNumber = _require.blockRefIsNumber;

var LogFilter = /*#__PURE__*/function (_BaseFilterWithHistor) {
  _inherits(LogFilter, _BaseFilterWithHistor);

  var _super = _createSuper(LogFilter);

  function LogFilter(_ref) {
    var _this;

    var provider = _ref.provider,
        params = _ref.params;

    _classCallCheck(this, LogFilter);

    _this = _super.call(this);
    _this.type = 'log';
    _this.ethQuery = new EthQuery(provider);
    _this.params = Object.assign({
      fromBlock: 'latest',
      toBlock: 'latest',
      address: undefined,
      topics: []
    }, params); // normalize address parameter

    if (_this.params.address) {
      // ensure array
      if (!Array.isArray(_this.params.address)) {
        _this.params.address = [_this.params.address];
      } // ensure lowercase


      _this.params.address = _this.params.address.map(function (address) {
        return address.toLowerCase();
      });
    }

    return _this;
  }

  _createClass(LogFilter, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
        var currentBlock, fromBlock, toBlock, params, newLogs;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentBlock = _ref2.currentBlock;
                // resolve params.fromBlock
                fromBlock = this.params.fromBlock;
                if (['latest', 'pending'].includes(fromBlock)) fromBlock = currentBlock;
                if ('earliest' === fromBlock) fromBlock = '0x0';
                this.params.fromBlock = fromBlock; // set toBlock for initial lookup

                toBlock = minBlockRef(this.params.toBlock, currentBlock);
                params = Object.assign({}, this.params, {
                  toBlock: toBlock
                }); // fetch logs and add to results

                _context.next = 9;
                return this._fetchLogs(params);

              case 9:
                newLogs = _context.sent;
                this.addInitialResults(newLogs);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref3) {
        var _this2 = this;

        var oldBlock, newBlock, toBlock, fromBlock, params, newLogs, matchingLogs;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                oldBlock = _ref3.oldBlock, newBlock = _ref3.newBlock;
                // configure params for this update
                toBlock = newBlock;

                // oldBlock is empty on first sync
                if (oldBlock) {
                  fromBlock = incrementHexInt(oldBlock);
                } else {
                  fromBlock = newBlock;
                } // fetch logs


                params = Object.assign({}, this.params, {
                  fromBlock: fromBlock,
                  toBlock: toBlock
                });
                _context2.next = 6;
                return this._fetchLogs(params);

              case 6:
                newLogs = _context2.sent;
                matchingLogs = newLogs.filter(function (log) {
                  return _this2.matchLog(log);
                }); // add to results

                this.addResults(matchingLogs);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function update(_x2) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "_fetchLogs",
    value: function () {
      var _fetchLogs2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(params) {
        var _this3 = this;

        var newLogs;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return pify(function (cb) {
                  return _this3.ethQuery.getLogs(params, cb);
                })();

              case 2:
                newLogs = _context3.sent;
                return _context3.abrupt("return", newLogs);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _fetchLogs(_x3) {
        return _fetchLogs2.apply(this, arguments);
      }

      return _fetchLogs;
    }()
  }, {
    key: "matchLog",
    value: function matchLog(log) {
      // check if block number in bounds:
      if (hexToInt(this.params.fromBlock) >= hexToInt(log.blockNumber)) return false;
      if (blockRefIsNumber(this.params.toBlock) && hexToInt(this.params.toBlock) <= hexToInt(log.blockNumber)) return false; // address is correct:

      var normalizedLogAddress = log.address && log.address.toLowerCase();
      if (this.params.address && normalizedLogAddress && !this.params.address.includes(normalizedLogAddress)) return false; // topics match:
      // topics are position-dependant
      // topics can be nested to represent `or` [[a || b], c]
      // topics can be null, representing a wild card for that position

      var topicsMatch = this.params.topics.every(function (topicPattern, index) {
        // pattern is longer than actual topics
        var logTopic = log.topics[index];
        if (!logTopic) return false;
        logTopic = logTopic.toLowerCase(); // normalize subTopics

        var subtopicsToMatch = Array.isArray(topicPattern) ? topicPattern : [topicPattern]; // check for wild card

        var subtopicsIncludeWildcard = subtopicsToMatch.includes(null);
        if (subtopicsIncludeWildcard) return true;
        subtopicsToMatch = subtopicsToMatch.map(function (topic) {
          return topic.toLowerCase();
        }); // check each possible matching topic

        var topicDoesMatch = subtopicsToMatch.includes(logTopic);
        return topicDoesMatch;
      });
      return topicsMatch;
    }
  }]);

  return LogFilter;
}(BaseFilterWithHistory);

module.exports = LogFilter;